<section class="d-flex border-border align-items-center background-background header-padding">
  <ion-buttons slot="end" *ngIf="!showDesktopMenu">
    <ion-menu-button color="secondary"></ion-menu-button>
  </ion-buttons>

  <div
    #titleWrapper
    class="page-title-wrapper"
    [class.w-100]="!hideTitle"
    [class.centered]="!showDesktopMenu"
    [class.ml-4]="!showDesktopMenu"
  >
    <p
      *ngIf="!hideTitle"
      [style.max-width.px]="titleWrapper.offsetWidth"
      class="page-title"
    >{{ title }} <span class="badge-place badge badge-pill badge-info ml-2">{{ badgeCount }}</span></p>

    <div class="ml-3">
      <ng-content></ng-content>
    </div>
  </div>

  <div
    class="d-flex align-items-center ms-auto"
    [class.ml-auto]="hideTitle"
  >

    <div class="switcher-box">
      <tablesready-theme-switcher
        *ngIf="showDesktopMenu"
        [toggleId]="'desktop-switcher-' + routeId"
      ></tablesready-theme-switcher>

      @if (user?.location && hasNotificationCenterFeature) {
        <frontend-paid-feature
          [user]="user"
          [visibility]="paidFeatureService.billingsVisibility === BillingVisibility.STARTER_PLAN_OUTSIDE_US ? BillingVisibility.FULL : undefined"
        >
          <div class="notification-button-wrapper">
            <ion-button fill="clear" class="color-primary notifications-button ml-3 mr-2 mb-1" (click)="openNotificationCenter()">
<!--              <ion-icon slot="icon-only" class="color-primary" name="notifications"></ion-icon>-->
              <tr-icon
                slot="icon-only"
                [icon]="icon.notifications"
                [size]="iconSize.large"
                [color]="iconColor.primary"
              ></tr-icon>
            </ion-button>

            <span *ngIf="(unreadCount$ | async) > 0" class="countbadge">
            <h4>{{ (unreadCount$ | async) > 99 ? '99+' : (unreadCount$ | async) }}</h4>
          </span>
          </div>
        </frontend-paid-feature>
      }

      <tablesready-location-switcher
        *ngIf="showDesktopMenu && hasBasicPermissions"
        [id]="routeId"
        class="ml-3"
      ></tablesready-location-switcher>
    </div>
  </div>

</section>

<div>
  <status-outlet [user]="user"></status-outlet>
</div>
